import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ResponseObject } from 'src/app/models/response-object.model';

@Injectable({
  providedIn: 'root'
})
export class GeographicRouteService {
  private URL = environment.api + "api/erp/geographic/route-point";

  constructor(private http: HttpClient) {}

  createRoutePoint(data: any, isBackend: boolean) {
	const params = {
		backend: isBackend.toString()
	};
    return this.http.post<ResponseObject>(this.URL + '/create', data,{ params });
  }


  getCurrentLocation(): Promise<{ latitude: number, longitude: number }> {
		return new Promise((resolve, reject) => {
			if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(
				(position) => {
				resolve({
					latitude: position.coords.latitude,
					longitude: position.coords.longitude
				});
				},
				(error) => {
				console.error('Error al obtener ubicación', error);
				reject(error);
				},
				{
				enableHighAccuracy: true,
				timeout: 10000, // 10 segundos
				maximumAge: 0
				}
			);
			} else {
			reject('La geolocalización no está soportada en este navegador');
			}
		});
	}

	getRoutesByCompanyAndDate(companyId: number, date: number) {
		const url = `${this.URL}/by-company?companyId=${companyId}&date=${date}`;
		return this.http.get<Record<string, any[]>>(url);
	}

	getRoutesByCompanyAndDateClientInvoice(companyId: number, date: number) {
		const url = `${this.URL}/by-company-client-invoice?companyId=${companyId}&date=${date}`;
		return this.http.get<Record<string, any[]>>(url);
	}

	getDetailsByRouteId(geoPointId) {
		return this.http.get(this.URL + '/details/' + geoPointId);
	}

}
